module.exports = __webpack_public_path__ + "static/media/user-profile.48c0e0af.svg";